function togglerModule() {
    this.init = function () {
        $("[data-mm-toggle-group]").on("click", function () {
            let group = $(this).data("mm-toggle-group");
            let target = $(this).data("mm-toggle");
            $("[data-mm-toggle-group='" + group + "']").removeClass("active");
            $(this).addClass("active");

            $("[data-toggle-content='" + group + "']")
                .find(".active")
                .removeClass("active show");

            $("#" + target).addClass("active show");
        });
    };
}

module.exports = togglerModule;
